module.exports = __webpack_public_path__ + "img/logo.7da11bb1.svg";